module.exports = __webpack_public_path__ + "static/media/integraiton.97a7ccb0.svg";